export const fromFirestore = folder => {
  return { ...folder };
};

export const toFirestore = folderToSave => {
  return {
    folder: { ...folderToSave },
  };
};
